import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import { computed, withDefaults } from 'vue'

type PropsType = {
  modelValue?: string | number | null
  placeholder?: string
  size?: string
  name?: string
  loading?: boolean
  useEventColor?: boolean
  options?: { value: string | number | null; label: string }[] | null
  bgColor?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleSelectBox',
  props: {
    modelValue: { default: null },
    placeholder: { default: '' },
    size: { default: 'medium' },
    name: null,
    loading: { type: Boolean, default: false },
    useEventColor: { type: Boolean, default: false },
    options: { default: () => [
    {
      value: null,
      label: '-',
    },
  ] },
    bgColor: { default: '' }
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: number | string | null): void
  (e: 'change', value: number | string | null): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: string | number | null, placeholder: string, size: string, name?: string, loading: boolean, useEventColor: boolean, options: { value: string | number | null; label: string }[] | null, bgColor: string };





const selectedValue = computed({
  get: () => props.modelValue,
  set(value) {
    emit('update:modelValue', value)
    // TODO 親コンポーネントで'update:modelValue'を利用すればchangeは不要だが、利用しているコンポーネントの修正がなるべく発生しないように2重でchangeイベントを追加している。
    emit('change', value)
  },
})

const event = computed<string | null>(() =>
  props.useEventColor && typeof props.modelValue === 'string' ? props.modelValue : null
)

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_unref(event), __props.size])
  }, [
    _createVNode(_component_el_select, {
      modelValue: _unref(selectedValue),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedValue) ? (selectedValue).value = $event : null)),
      class: _normalizeClass(__props.bgColor),
      placeholder: __props.placeholder,
      loading: __props.loading
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (item) => {
          return (_openBlock(), _createBlock(_component_el_option, {
            key: item.value,
            label: item.label,
            value: item.value,
            disabled: item.disabled
          }, null, 8, ["label", "value", "disabled"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue", "class", "placeholder", "loading"])
  ], 2))
}
}

})